
type Language = {
    id: string,
    name: string,
    iconClass: string
}

export type TranslatedText = () => string;

export var currentLanguageId: string = "de";
export var languages: Language[] = [
    {
        id: 'de',
        name: 'deutsch',
        iconClass: 'img_flag-german'
    }, {
        id: 'en',
        name: "english",
        iconClass: 'img_flag-english'
    }
]

export type ErrormessageWithId = {
    message: string,
    id: string
}

export function lm(map: Record<string, string>): string {
    let template = map[currentLanguageId];
    if(!template){
        for(let lang of languages){
            template = map[lang.id];
            if(template) break;
        }
        if(!template){
            return "Missing template for language " + currentLanguageId;
        }
    }

    return template;
}

export function lInterval(map: Record<string, [number, number]>): [number, number] {
    let interval = map[currentLanguageId];
    if(!interval){
        for(let lang of languages){
            interval = map[lang.id];
            if(interval) break;
        }
        if(!interval){
            return [0, 0];
        }
    }

    return interval;
}

export function le(map: Record<string, string>): ErrormessageWithId {
    let template = map[currentLanguageId];
    if(!template){
        for(let lang of languages){
            template = map[lang.id];
            if(template) break;
        }
        if(!template){
            return {
                id: "MissingTemplate",
                message: "Missing template for language " + currentLanguageId
            }
        }
    }

    let id = map["id"] || "no id";

    return {
        message: template,
        id: id
    }
}

export function setLanguageId(lang: string){
    currentLanguageId = lang;
}

